import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import withStyles from "utils/withStyles";
import styles from "./styles";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.bubble.css";
import "../common/quill-preview.css";
import "./styles.css";
import {
  AddButton,
  EditButton,
  DeleteButton,
  DeployButton,
  ExportButton,
  ImportButton,
} from "../common/Buttons";
import SearchBox from "../common/SearchBox";
import ContentHeader from "../common/ContentHeader";
import TableGenerator from "../../../../../Common/TableGenerator";
import _flatten from "lodash/flatten";
import CrudDialog from "../common/CrudDialog";
import moment from "dayjs";
import { useSnackbar } from "notistack";
import {
  handleServerErrors,
  handleMultiFilterSearch,
} from "../../utiles/helpers";
import Tooltip from "@mui/material/Tooltip";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import Grid from "utils/Grid";
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";
import Autocomplete from '@mui/material/Autocomplete';
import CheckboxField from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/HighlightOff";
import { Loader } from "components/Common";
import {
  setDropdownProducts,
  setProductCategoriesData,
  setReportedCategoriesData,
  setProductSettingsData,
} from "redux/actions";
import RichTextEditor from "../common/RichTextEditor";
import {
  convertUtcToLocal,
  currencyFormatter,
  dateFormatter,
  getTimeZoneDifference,
  taxFormatter,
  stripHtml,
} from "utils/helpers";
import {
  FileUploadInfoButton,
  FileUploadButton,
  VideoUploadButton,
} from "../common/Buttons";
import ImagesModal from "./images_info";
import InfoModal from "components/Common/AlertDialog/info_dialogue";
import useFrontendTable from "./useFrontendTable";
import DialogWithTable from "./addLanguage";

const filterLabels = {
  product_name: "product_name",
  product_sku: "product_sku",
  product_category: "categories__category_name",
  product_brand: "brand__brand",
  operator: "operator__business_name",
  package: "package_type",
  status: "status",
};

const sortLabels = {
  brand_name: "brand__brand",
  "-brand_name": "-brand__brand",
  product_name: "product_name",
  "-product_name": "-product_name",
};

const deviceTypeFields = [
  "product_name",
  "product_sku",
  "product_category",
  "product_brand",
  "operator",
  "package",
  "status",
];

const NO_SALE_DAYS = [
  { label: "Sunday", value: "Sunday" },
  { label: "Monday", value: "Monday" },
  { label: "Tuesday", value: "Tuesday" },
  { label: "Wednesday", value: "Wednesday" },
  { label: "Thursday", value: "Thursday" },
  { label: "Friday", value: "Friday" },
  { label: "Saturday", value: "Saturday" },
];

const Product = () => {
  const classes = styles();
  const [openProductModal, setOpenProductModal] = useState(false);
  const [openDescriptionModal, setOpenDescriptionModal] = useState(false);
  const [descriptionPreview, setDescriptionPreview] = useState("");
  const [deviceTypeList, setDeviceList] = useState([]);
  const [dataCount, setDataCount] = useState(0);
  const [page, setPage] = useState(0);
  const [nextPage, setNextPage] = useState(null);
  const [previousPage, setPreviousPage] = useState(null);
  const [firstPage, setFirstPage] = useState(null);
  const [lastPage, setLastPage] = useState(null);
  const [ordering, setOrdering] = useState("-id");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [categoryEditModal, setCategoryEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [forcedeleteModal, setForceDeleteModal] = useState(false);
  const [modulesSelected, setModulesSelected] = useState([]);
  const [filterable, setFilterable] = useState(deviceTypeFields);
  const [query, setQuery] = useState("");
  const [loader, setLoader] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [reportedCategoryList, setReportedCategoryList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [languageList, setLanguageList] = useState([]);
  const [subCategory, setSubCategory] = useState(false);
  const [isMutating, setIsMutating] = useState(false);
  const [searchQuery, setSearchQuery] = useState({});
  const [importError, setImportError] = useState([]);
  const [isInfo, setIsInfo] = useState(false);
  const [crudLoader, setCrudLoader] = useState(false);
  const [showTimePeriod, setShowTimePeriod] = useState(false);
  const [fileTypeValidation, setFileTypeValidation] = useState("");
  const [productName, setProductName] = useState("");
  const [productNameError, setProductNameError] = useState("");
  const [packageName, setPackageName] = useState("");
  const [productSKU, setProductSKU] = useState("");
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [categorySearchQuery, setCategorySearchQuery] = useState("");
  const [selectedDays, setSelectedDays] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [selectedReportedCategory, setSelectedReportedCategory] =
    useState(null);
  const [selectedOperator, setSelectedOperator] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState({
    label: "Enable",
    value: "Enable",
  });
  const [selectedAgeRestriction, setSelectedAgeRestriction] = useState({
    label: "Not Required",
    value: "0",
  });
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [salePrice, setSalePrice] = useState("");
  const [salePriceError, setSalePriceError] = useState("");
  const [productCost, setProductCost] = useState("");
  const [productCostError, setProductCostError] = useState("");
  const [sellingStartTime, setSellingStartTime] = useState("00:00");
  const [sellingEndTime, setSellingEndTime] = useState("00:00");
  const [purchaseLimit, setPurchaseLimit] = useState("");
  const [purchaseLimitError, setPurchaseLimitError] = useState("");
  const [shelfLife, setShelfLife] = useState("");
  const [weight, setWeight] = useState("");
  const [weightError, setWeightError] = useState("");
  const [productTax, setProductTax] = useState("0.0000");
  const [productTaxError, setProductTaxError] = useState("");
  const [hopperLimit, setHopperLimit] = useState(1);
  const [hopperLimitError, setHopperLimitError] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [subtitleError, setSubtitleError] = useState("");
  const [description, setDescription] = useState("");
  const [languageAddModal, setLanguageAddModal] = useState(false);

  const [numberOfFiles, setNumberOfFiles] = useState(0);
  const [openAddlImagesModal, setOpenAddlImagesModal] = useState(false);
  const [imagesData, setImagesData] = useState(null);
  const [allImages, setAllImages] = useState([]);

  const [barcodeFileName, setBarcodeFileName] = useState("");
  const [barcodeFile, setBarcodeFile] = useState(null);
  const [productPictureName, setProductPictureName] = useState("");
  const [productPicture, setProductPicture] = useState(null);
  const [moreInfoFileName, setMoreInfoFileName] = useState("");
  const [moreInfoFile, setMoreInfoFile] = useState(null);
  const [ingredientsFileName, setIngredientsFileName] = useState("");
  const [ingredientsFile, setIngredientsFile] = useState(null);
  const [instructionsFileName, setInstructionsFileName] = useState("");
  const [instructionsFile, setInstructionsFile] = useState(null);

  const [recommendProduct, setRecommendProduct] = useState(false);
  const [checkExtension, setCheckExtension] = useState({
    product_picture: true,
    barcode: true,
    more_info: true,
    ingredients: true,
    instructions_video: true,
  });
  const [selectedLabelType1, setSelectedLabelType1] = useState({
    label: "",
    value: "",
  });
  const [selectedLabelType2, setSelectedLabelType2] = useState({
    label: "",
    value: "",
  });
  const [labelTitle1, setLabelTitle1] = useState("");
  const [labelTitle2, setLabelTitle2] = useState("");
  const [labelAttribute1, setLabelAttribute1] = useState("");
  const [labelAttribute2, setLabelAttribute2] = useState("");
  const [hexCode1, setHexCode1] = useState("#000000");
  const [hexCode2, setHexCode2] = useState("#000000");
  const dispatch = useDispatch();

  const image_extensions_array = [
    "jpg",
    "jpeg",
    "png",
    "JPG",
    "JPEG",
    "PNG",
    "gif",
    "GIF",
  ];
  const video_extensions_array = ["mp4", "MP4", "mov", "MOV"];

  const AGE_RESTRICTION_VALUES = [
    { label: "Not Required", value: "0" },
    { label: "18", value: "18" },
    { label: "21", value: "21" },
  ];

  const filteredCategories = categoryList.filter((category) =>
    category.category_name
      ?.toLowerCase()
      .includes(categorySearchQuery.toLowerCase())
  );

  const {
    tableData,
    addEntry,
    editEntry,
    deleteEntry,
    resetData,
    setTableData,
    updateExisting,
    cancelEntry,
    setTemporaryData,
    updateExistingProducts,
  } = useFrontendTable();

  const current_user = useSelector((state) => state.userReducer.current_user);
  const enable_product_language = useSelector(
    (state) => state.productsSettingsReducer.enable_product_language
  );
  const productSettingsData = useSelector(
    (state) => state.initialLoadReducer.productSettingsData
  );
  const productsData = useSelector(
    (state) => state.dropdownReducer.productsData
  );
  const operatorsData = useSelector(
    (state) => state.dropdownReducer.operatorsData
  );
  const { enqueueSnackbar } = useSnackbar();

  const updateProductDropdownData = (mode, payload, currentProducts) => {
    let updatedProducts;

    const isArray = Array.isArray(payload);
    const items = isArray ? payload : [payload];

    switch (mode) {
      case "add":
        updatedProducts = [
          ...currentProducts,
          ...items.filter(
            (item) => !currentProducts.some((p) => p.value === item.value)
          ),
        ];
        break;

      case "edit":
        updatedProducts = currentProducts.map((p) =>
          items.find((i) => i.value === p.value)
            ? {
                ...p,
                ...items.find((i) => i.value === p.value),
              }
            : p
        );
        break;

      case "delete":
        const idsToRemove = items.map((item) => item.value);
        updatedProducts = currentProducts.filter(
          (p) => !idsToRemove.includes(p.value)
        );
        break;

      default:
        updatedProducts = currentProducts;
    }

    return updatedProducts;
  };

  const fields = [
    { key: "id", columnName: "ID", label: "ID", type: "text", visible: true },
    {
      key: "product_sku",
      columnName: "Product SKU",
      label: "Product SKU",
      type: "text",
      visible: true,
      required: true,
      render: (value) => value || "---",
    },
    {
      key: "product_name",
      columnName: "Product Name",
      label: "Product Name",
      type: "text",
      visible: true,
      render: (value) => value ?? "---",
    },

    {
      key: "operator_name",
      columnName: "Operator",
      label: "Operator",
      type: "text",
      visible: true,
      required: true,
      render: (value) => value ?? "---",
    },
    {
      key: "reported_category_name",
      columnName: "Reported Category",
      type: "text",
      visible: productSettingsData["enable_reported_category"] || false,
      required: true,
      render: (value) => value ?? "---",
    },
    {
      key: "category_list",
      columnName: "Product Categories",
      label: "Product Categories",
      type: "text",
      visible: true,
      disableSorting: true,
      render: (value) =>
        value ? value.map((cat) => cat.category_name).join(", ") : "---",
    },
    {
      key: "sub_category_name",
      columnName: "Product Subcategory",
      label: "Product Subcategory",
      type: "text",
      visible: (subCategory && subCategory["enable_subcategory"]) || false,
      render: (value) => value ?? "---",
    },
    {
      key: "brand_name",
      columnName: "Product Brand",
      label: "Product Brand",
      type: "text",
      visible: true,
      render: (value) => value ?? "---",
    },
    {
      key: "product_picture",
      columnName: "Picture",
      label: "Product Picture",
      type: "fileWithPeriod",
      form: true,
      visible: true,
      disableSorting: true,
      render: (_, values) =>
        values.product_picture && (
          <div
            style={{
              height: 64,
              width: 64,
            }}
          >
            <div
              style={{
                backgroundImage: `url(${values.product_picture})`,
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                height: "100%",
                width: "100%",
              }}
            ></div>
          </div>
        ),
    },
    {
      key: "goods_code",
      columnName: "Goods Code",
      label: "Goods Code",
      type: "text",
      visible: false,
      render: (value) => value ?? "---",
    },
    {
      key: "barcode_of_product",
      columnName:
        subCategory && subCategory["change_barcode_to_desc_img"]
          ? "Description Image"
          : "BarCode",
      width: 100,
      label:
        subCategory && subCategory["change_barcode_to_desc_img"]
          ? "Description Image"
          : "BarCode",
      type: "file",
      form: true,
      visible: (subCategory && subCategory["enable_barcode"]) ?? true,
      disableSorting: true,
      render: (_, values) =>
        values.barcode_of_product && (
          <div
            style={{
              height: 64,
            }}
          >
            <div
              style={{
                backgroundImage: `url(${values.barcode_of_product})`,
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                height: "100%",
                width: "100%",
              }}
            ></div>
          </div>
        ),
    },
    {
      key: "more_info_img",
      columnName: "More Info",
      width: 100,
      label: "More Info",
      type: "file",
      form: true,
      visible: (subCategory && subCategory["enable_info_img"]) || false,
      disableSorting: true,
      render: (_, values) =>
        values.more_info_img && (
          <div
            style={{
              height: 64,
            }}
          >
            <div
              style={{
                backgroundImage: `url(${values.more_info_img})`,
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                height: "100%",
                width: "100%",
              }}
            ></div>
          </div>
        ),
    },
    {
      key: "ingredients_img",
      columnName: "Ingredients",
      width: 100,
      label: "Ingredients",
      type: "file",
      form: true,
      visible: (subCategory && subCategory["enable_ingredient_img"]) || false,
      disableSorting: true,
      render: (_, values) =>
        values.ingredients_img && (
          <div
            style={{
              height: 64,
            }}
          >
            <div
              style={{
                backgroundImage: `url(${values.ingredients_img})`,
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                height: "100%",
                width: "100%",
              }}
            ></div>
          </div>
        ),
    },
    {
      key: "package_type",
      columnName: "Package",
      label: "Package",
      type: "text",
      visible: true,
      render: (value) => value ?? "---",
    },
    {
      key: "price",
      columnName: "Sale Price ($)",
      label: "Price ($)",
      type: "text",
      visible: true,
      render: (value) => currencyFormatter(value) ?? "---",
    },
    {
      key: "cost",
      columnName: "Cost ($)",
      label: "Cost ($)",
      type: "text",
      visible: true,
      render: (value) => currencyFormatter(value) ?? "---",
    },
    {
      key: "product_tax",
      columnName: "Tax (%)",
      label: "Tax (%)",
      type: "text",
      visible:
        (subCategory && subCategory["enable_taxes_per_product"]) || false,
      render: (value) => taxFormatter(value) ?? "0.0000",
    },
    {
      key: "weight",
      columnName: "Weight in grams",
      label: "Weight (in grams)",
      type: "text",
      visible: true,
      required: true,
      render: (value) => value ?? "---",
    },
    {
      key: "shelf_life",
      columnName: "Shelf life (days)",
      label: "Shelf life (days)",
      type: "text",
      visible: true,
      render: (value) => value ?? "---",
    },
    {
      key: "purchase_limit",
      columnName: "Purchase Limit",
      label: "Purchase Limit",
      type: "text",
      visible: true,
      render: (value) => value ?? "---",
    },
    {
      key: "hopper_limit",
      columnName: "Hopper Limit",
      label: "Hopper Limit",
      type: "text",
      visible:
        (subCategory && subCategory["enable_multi_pickup"]) || false,
      render: (value) => value ?? 1,
    },
    // {
    //   key: "heating_time",
    //   columnName: "Heating time",
    //   label: "Heating time",
    //   type: "text",
    //   visible: true,
    //   render: (value) => value ?? "---",
    // },
    {
      key: "age_restriction",
      columnName: "Age Restriction",
      label: "Age Restriction",
      type: "text",
      visible: true,
      render: (value) => (value === "0" ? "Not Required" : value ?? "---"),
    },
    {
      key: "status",
      columnName: "Status",
      label: "Status",
      type: "text",
      visible: true,
      required: true,
      render: (value) => (value && value !== "undefined" ? value : "---"),
    },
    {
      key: "product_description",
      columnName: "Subtitle",
      label: "Subtitle",
      type: "text",
      visible: true,
      render: (value) => (
        <Tooltip title={value} aria-label="description">
          <span>{value || "---"}</span>
        </Tooltip>
      ),
    },
    {
      key: "rich_long_description",
      columnName: "Description",
      label: "Description",
      type: "textarea",
      visible: true,
      render: (_, values) =>
        (values.rich_long_description || values.long_description) && (
          <div
            onClick={() => {
              setDescriptionPreview(
                values.rich_long_description || values.long_description
              );
              setOpenDescriptionModal(true);
            }}
            style={{
              fontStyle: "italic",
              cursor: "pointer",
              color: "#0000EE",
              textDecoration: "underline",
            }}
          >
            Preview Description
          </div>
        ),
    },
    {
      key: "created_at",
      columnName: "Creation Time",
      label: "Creation Time",
      type: "text",
      visible: true,
      render: (value) => dateFormatter(convertUtcToLocal(value), true),
    },
    {
      key: "updated_at",
      columnName: "Update time stamp",
      label: "Update time stamp",
      type: "text",
      visible: true,
      render: (value) => dateFormatter(convertUtcToLocal(value), true),
    },
  ];

  const taxValidation = (value) => {
    if (
      !isNaN(parseFloat(value)) &&
      Number(value) >= 0 &&
      Number(value) <= 100 &&
      (("" + value)?.split(".")?.[1]
        ? value?.split(".")?.[1]?.length <= 4
        : true)
    ) {
      return true;
    }
  };

  const validateTax = (value) => {
    if (
      !isNaN(parseFloat(value)) &&
      Number(value) >= 0 &&
      Number(value) <= 100 &&
      (("" + value)?.split(".")?.[1]
        ? value?.split(".")?.[1]?.length <= 4
        : true)
    ) {
      return "";
    }
    return "Enter tax between 0 to 100, only four digits are allowed after decimal";
  };

    const validateHopperLimit = (value) => {
    if (value =="") return ""
    if (
      !isNaN(value) &&
      Number.isInteger(Number(value)) &&
      Number(value) >= 1 &&
      Number(value) <= 99
    ) {
      return "";
    }
    return "Hopper limit must be a whole number between 1 and 99"
  };

  const validateBulkHopperLimit = (value) => {
    if (value =="") return true

    if (
      !isNaN(value) &&
      Number.isInteger(Number(value)) &&
      Number(value) >= 1 &&
      Number(value) <= 99
    ) {
      return true
    }
    return false
  };

  const validateProductName = (value) => {
    if (value.trim() === "") {
      return "Required";
    }
    if (value.length > 70) {
      return "Max length 70";
    }
    return "";
  };

  const validateSubtitle = (value) => {
    if (value.length > 100) {
      return "Max length 100";
    }
    return "";
  };

  const validateWeight = (value) => {
    if (!value) return "";
    if (
      !isNaN(parseFloat(value)) &&
      Number(value) >= 0 &&
      (value?.split(".")?.[1] ? value?.split(".")?.[1]?.length <= 3 : true)
    ) {
      return "";
    }
    return "Enter a valid number, with upto 3 decimal places";
  };

  const validatePurchaseLimit = (value) => {
    if (value.trim() === "" || value === undefined || value === null) {
      return "";
    }
    if (Number(value) < 1 || Number(value) > 5) {
      return "Quantity should be between 1 to 5";
    }
    return "";
  };

  const validateSalePrice = (value) => {
    if (value.trim() === "") {
      return "Required";
    }
    if (
      !isNaN(parseFloat(value)) &&
      Number(value) >= 0 &&
      Number(value) <= 100000 &&
      (value?.split(".")?.[1] ? value?.split(".")?.[1]?.length <= 2 : true)
    ) {
      return "";
    }
    return "Enter Sale price between 0 to 100000, only two digits are allowed after decimal";
  };

  const handleFileChange = async (
    e,
    setFileName,
    setFile,
    key,
    isImage = true
  ) => {
    let extension = e[0].name.split(".")[1];
    if (
      isImage
        ? image_extensions_array.includes(extension)
        : video_extensions_array.includes(extension)
    ) {
      setCheckExtension((prev) => ({ ...prev, [key]: true }));
      setFileName(e[0].name);
      setFile(e[0]);
    } else {
      setFileName("");
      setFile(null);
      setCheckExtension((prev) => ({ ...prev, key: false }));
    }
  };

  const getImages = (field, e) => {
    let images = [];
    for (let i = 0; i < e.length; i++) {
      images.push(e[i]);
    }

    // append to the existing set instead of replacing it; 5 backend slots max
    const merged = [...allImages, ...images].slice(0, 5);
    setImagesData(
      merged.map((x) => [
        getImageSrc(x),
        typeof x === "string" ? x.split("/").pop().split("?")[0] : x.name,
      ])
    );
    setNumberOfFiles(merged.length);
    setAllImages(merged);
  };

  const removeImages = (val) => {
    let images = [];
    for (let i = 0; i < allImages.length; i++) {
      if (typeof allImages[i] === "string") {
        if (allImages[i] !== val[0]) {
          images.push(allImages[i]);
        }
      } else {
        if (allImages[i].name !== val[1]) {
          images.push(allImages[i]);
        }
      }
    }
    setNumberOfFiles(images.length);
    setImagesData(
      images?.map((x) => [
        getImageSrc(x),
        typeof x === "string" ? x.split("/").pop().split("?")[0] : x.name,
      ])
    );
    setAllImages(images);
  };

  const validateProductCost = (value) => {
    if (value.trim() === "") {
      return "Required";
    }
    if (
      !isNaN(parseFloat(value)) &&
      Number(value) >= 0 &&
      Number(value) <= 100000 &&
      (value?.split(".")?.[1] ? value?.split(".")?.[1]?.length <= 2 : true)
    ) {
      return "";
    }
    return "Enter Cost price between 0 to 100000, only two digits are allowed after decimal";
  };

  const getImageSrc = (image) => {
    return typeof image === "string" ? image : URL.createObjectURL(image);
  };

  const getComponents = (position = 1) => {
    if (subCategory && subCategory["enable_subcategory"] && position === 1) {
      return (
        <Grid xs={6}>
          <Autocomplete
            id="combo-box-demo"
            size="small"
            options={
              categoryList.length
                ? categoryList
                    .filter((data) => data.is_subcategory)
                    .map((x) => ({
                      label: x.category_name,
                      value: x.id,
                    }))
                : [{ label: "", value: "" }]
            }
            style={{ display: "block" }}
            value={selectedSubCategory}
            onChange={(_, val) => setSelectedSubCategory(val)}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            getOptionLabel={(option) => option?.label || ""}
            renderInput={(params) => (
              <TextField
                {...params}
                style={{ width: "100%" }}
                label="Product Subcategory"
                variant="outlined"
              />
            )}
          />
        </Grid>
      );
    } else if (
      (!(subCategory && subCategory["enable_subcategory"]) && position === 1) ||
      (subCategory && subCategory["enable_subcategory"] && position === 2)
    ) {
      return (
        <Grid xs={6}>
          <Autocomplete
            id="combo-box-demo"
            size="small"
            required
            options={AGE_RESTRICTION_VALUES}
            style={{ display: "block" }}
            disabled={
              JSON.parse(localStorage.getItem("scanner_state")) ? false : true
            }
            value={selectedAgeRestriction}
            onChange={(_, val) => setSelectedAgeRestriction(val)}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            getOptionLabel={(option) => option?.label || ""}
            renderInput={(params) => (
              <TextField
                {...params}
                required={true}
                style={{ width: "100%" }}
                label="Age Restriction"
                variant="outlined"
              />
            )}
          />
        </Grid>
      );
    } else if (position === 3) {
      return !(
        current_user.type === "FO" ||
        current_user.type === "OP" ||
        current_user.type === "DU"
      ) ? (
        <Grid xs={6}>
          <Autocomplete
            id="combo-box-demo"
            size="small"
            options={operatorsData.slice(1).map((operator) => ({
              label: `${operator.label} || (${operator.customer_type})`,
              value: operator.value,
            }))}
            style={{ display: "block" }}
            value={selectedOperator}
            onChange={(_, val) => setSelectedOperator(val)}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            getOptionLabel={(option) => option?.label || ""}
            renderInput={(params) => (
              <TextField
                {...params}
                style={{ width: "100%" }}
                label="Operator"
                variant="outlined"
              />
            )}
          />
        </Grid>
      ) : null;
    } else if (
      subCategory &&
      subCategory["enable_reported_category"] &&
      position === 4
    ) {
      return (
        <Grid xs={6}>
          <Autocomplete
            id="combo-box-demo"
            size="small"
            options={
              reportedCategoryList.length
                ? [
                    ...reportedCategoryList.map((x) => ({
                      label: x.category_name,
                      value: x.id,
                    })),
                  ]
                : [{ label: "", value: "" }]
            }
            style={{ display: "block" }}
            value={selectedReportedCategory}
            onChange={(_, val) => setSelectedReportedCategory(val)}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            getOptionLabel={(option) => option?.label || ""}
            renderInput={(params) => (
              <TextField
                {...params}
                style={{ width: "100%" }}
                label="Reported Category"
                variant="outlined"
              />
            )}
          />
        </Grid>
      );
    } else if (
      (!(
        productSettingsData && productSettingsData["enable_reported_category"]
      ) &&
        position === 4) ||
      (productSettingsData &&
        productSettingsData["enable_reported_category"] &&
        position === 5)
    ) {
      return (
        <Grid xs={6}>
          <TextField
            type="text"
            variant="outlined"
            size="small"
            label="Package"
            value={packageName}
            onChange={(e) => setPackageName(e.target.value)}
            onBlur={(e) => {
              setPackageName(e.target.value?.trim());
            }}
            style={{ width: "100%" }}
          />
        </Grid>
      );
    } else {
      return null;
    }
  };

  const handleTimeChange = (newTime, setter) => {
    if (newTime) {
      setter(newTime);
    } else {
      setter("00:00");
    }
  };

  const editFields1 = [
    [
      {
        key: "categories",
        label: "Product Categories",
        columnName: "Product Categories",
        type: "multiAutoComplete",
        show: true,
        // required: true,
        freeSolo: false,
        inputProps: {
          tabIndex: "2",
        },
        options: categoryList.length
          ? categoryList
              .filter((data) => !data.is_subcategory)
              .map((x) => ({
                label: x.category_name,
                value: x.id,
              }))
          : [{ label: "", value: null }],
        visible: true,
      },
    ],
    [
      {
        key: "brand",
        label: "Product Brand",
        columnName: "Product Brand",
        type: "autocomplete",
        // required: true,
        show: true,
        inputProps: {
          tabIndex: "3",
        },
        freeSolo: false,
        options: brandList.length
          ? [...brandList.map((x) => ({ label: x.brand, value: x.id }))]
          : [{ label: "", value: null }],
        visible: true,
      },
    ],
    [
      {
        key: "age_restriction",
        columnName: "Age Restriction",
        label: "Age Restriction",
        visible: true,
        freeSolo: false,
        required: true,
        inputProps: {
          tabIndex: "13",
        },
        show: true,
        disabled: JSON.parse(localStorage.getItem("scanner_state"))
          ? false
          : true,
        type: "autocomplete",
        options: [
          { label: "Not Required", value: "0" },
          { label: "18", value: 18 },
          { label: "21", value: 21 },
        ],
        defaultValue: { label: "Not Required", value: "0" },
      },
      {
        key: "product_tax",
        columnName: "Tax (%)",
        label: "Tax (%)",
        type: "text",
        value: "0.0000",
        inputProps: {
          tabIndex: "9",
        },
        visible:
          (subCategory && subCategory["enable_taxes_per_product"]) || false,
        required: false,
        validations: [
          {
            type: "custom",
            value: (fieldValue) =>
              subCategory && subCategory["enable_taxes_per_product"]
                ? taxValidation(fieldValue)
                : true,
            message:
              "Enter tax between 0 to 100, only four digits are allowed after decimal",
          },
        ],
      },
    ],

    [
      {
        key: "selling_start_time",
        label: "Start Time for Selling",
        type: "time",
        visible:
          showTimePeriod &&
          subCategory &&
          subCategory["enable_product_selling_time"],
      },
      {
        key: "selling_end_time",
        label: "End Time for Selling",
        type: "time",
        visible:
          showTimePeriod &&
          subCategory &&
          subCategory["enable_product_selling_time"],
      },
    ],
    {
      key: "hopper_limit",
      columnName: "Hopper Limit",
      label: "Hopper Limit",
      type: "text",
      visible:
        (subCategory && subCategory["enable_multi_pickup"]) || false,
      render: (value) => value ?? 1,
      validations: [
        {
          type: "custom",
          value: (fieldValue) => validateBulkHopperLimit(fieldValue),
          message: "Hopper limit must be a whole number between 1 and 99",
        },
      ],
    },
    [
      {
        key: "no_sale_days",
        label: "No Sale Days",
        visible:
          showTimePeriod &&
          subCategory &&
          subCategory["enable_product_selling_time"],
        type: "multiAutoComplete",
        inputProps: {
          tabIndex: "16",
        },
        options: [
          { label: "Sunday", value: "Sunday" },
          { label: "Monday", value: "Monday" },
          { label: "Tuesday", value: "Tuesday" },
          { label: "Wednesday", value: "Wednesday" },
          { label: "Thursday", value: "Thursday" },
          { label: "Friday", value: "Friday" },
          { label: "Saturday", value: "Saturday" },
        ],
        show: true,
        unclosable: true,
      },
    ],
  ];

  const setup = () => {
    setLoader(true);
    setDeviceList([]);
    setModulesSelected([]);
  };

  const handleRes = (data) => {
    setDeviceList(data.results);
    setNextPage(data.next);
    setPreviousPage(data.previous);
    setFirstPage(data.first);
    setLastPage(data.last);
    setLoader(false);
    setDataCount(data.count);
  };

  const getDeviceType = async (order, max, customPage = page) => {
    const params = {
      ...searchQuery,
      limit: max ? max : rowsPerPage,
      ordering: order ? order : ordering,
      state: "all",
      page: customPage + 1,
      variant: "products",
    };

    // if (current_user.type === "FO" || current_user.type === "OP") {
    //   params.operator = current_user.id;
    // }

    setup();
    const { data } = await window.axiosIns("/products", { params });
    handleRes(data);
  };

  const getCategory = () => {
    window
      .axiosIns("/categories", {
        params: { all: true, ordering: "category_name" },
      })
      .then(({ data = {} }) => {
        setCategoryList(data.results);
        dispatch(setProductCategoriesData(data.results));
      })
      .catch((err) => {
        if (err.detail) {
          enqueueSnackbar(err.detail);
        } else {
          handleServerErrors(
            err,
            enqueueSnackbar,
            "Could not get categories. Try again."
          );
        }
      });
  };

  const getReportedCategory = () => {
    window
      .axiosIns("/reported_category", {
        params: { all: true, ordering: "category_name" },
      })
      .then(({ data = {} }) => {
        setReportedCategoryList(data.results);
        dispatch(setReportedCategoriesData(data.results));
      })
      .catch((err) => {
        if (err.detail) {
          enqueueSnackbar(err.detail);
        } else {
          handleServerErrors(
            err,
            enqueueSnackbar,
            "Could not get categories. Try again."
          );
        }
      });
  };

  const getProductSettings = async () => {
    window
      .axiosIns("/products_settings")
      .then(({ data = {} }) => {
        setSubCategory(data.results?.[0]);
        dispatch(setProductSettingsData(data.results?.[0]));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getBrand = async () => {
    window
      .axiosIns("/brand", { params: { all: true, ordering: "brand" } })
      .then(({ data = {} }) => {
        setBrandList(data.results);
      })
      .catch((err) => {
        if (err.detail) {
          enqueueSnackbar(err.detail);
        } else {
          handleServerErrors(
            err,
            enqueueSnackbar,
            "Could not get brands. Try again."
          );
        }
      });
  };

  const getLanguages = async () => {
    window
      .axiosIns("/languages", { params: { all: true } })
      .then(({ data = {} }) => {
        setLanguageList(data.results);
      })
      .catch((err) => {
        if (err.detail) {
          enqueueSnackbar(err.detail);
        } else {
          handleServerErrors(
            err,
            enqueueSnackbar,
            "Could not get brands. Try again."
          );
        }
      });
  };

  useEffect(() => {
    getProductSettings();
    getDeviceType();
    getCategory();
    getReportedCategory();
    getBrand();
    getLanguages();
    setFileTypeValidation(".mov,.mp4,.MOV,.MP4");
  }, []);

  useEffect(() => {
    if (
      selectedAgeRestriction?.value.toString() === "0" ||
      selectedAgeRestriction === null
    ) {
      setShowTimePeriod(false);
    } else {
      setShowTimePeriod(true);
    }
  }, [selectedAgeRestriction]);

  const isFileTypeValid = (fileName) => {
    if (fileName) {
      const validExtensions = fileTypeValidation.split(",");
      const extension = fileName.split(".").pop();
      return validExtensions.includes("." + extension);
    }
    return true;
  };

  const handleAdd = () => {
    if (productName === "") {
      enqueueSnackbar("'Product Name' cannot be empty");
      return;
    }
    if (salePrice === "") {
      enqueueSnackbar("'Sale Price' cannot be empty");
      return;
    }
    if (
      (selectedCategories.some((category) => category.weight_limit > 0) ||
        selectedReportedCategory) &&
      !weight
    ) {
      enqueueSnackbar("'Weight' cannot be empty");
      return;
    }
    if (productCost === "") {
      enqueueSnackbar("'Product Cost' cannot be empty");
      return;
    }
    if (
      productNameError ||
      salePriceError ||
      productCostError ||
      purchaseLimitError ||
      weightError ||
      productTaxError ||
      hopperLimitError ||
      subtitleError
    ) {
      enqueueSnackbar("Please correct the highlighted errors");
      return;
    }
    if (
      subCategory &&
      subCategory["enable_product_selling_time"] &&
      selectedAgeRestriction.value !== "0"
    ) {
      if (!sellingStartTime && sellingEndTime) {
        enqueueSnackbar("'Start Time for Selling' cannot be empty");
        return;
      }
      if (sellingStartTime && !sellingEndTime) {
        enqueueSnackbar("'End Time for Selling' cannot be empty");
        return;
      }
    }
    if (instructionsFile && !isFileTypeValid(instructionsFile?.name)) {
      enqueueSnackbar("Please select a valid file for instruction video.");
      return;
    }
    if (subCategory && subCategory["enable_variant_management"]) {
      if (selectedLabelType1.value !== "") {
        if (labelTitle1 === "") {
          enqueueSnackbar("Please fill 'Label Title 1'");
          return;
        }
        if (labelAttribute1 === "") {
          enqueueSnackbar("Please fill 'Label Attribute 1'");
          return;
        }
        if (selectedLabelType1.value === "color") {
          if (hexCode1 === "") {
            enqueueSnackbar("Please fill 'Hex Code 1'");
            return;
          }
        }
      }

      if (selectedLabelType2.value !== "") {
        if (labelTitle2 === "") {
          enqueueSnackbar("Please fill 'Label Title 2'");
          return;
        }
        if (labelAttribute2 === "") {
          enqueueSnackbar("Please fill 'Label Attribute 2'");
          return;
        }
        if (selectedLabelType2.value === "color") {
          if (hexCode2 === "") {
            enqueueSnackbar("Please fill 'Hex Code 2'");
            return;
          }
        }
      }
    }

    const fd = new FormData();
    // images && fd.append("images", images);

    if (allImages && allImages.length) {
      for (let i = 0; i < allImages.length; i++) {
        fd.append(`img${i + 1}`, allImages[i]);
      }
    }
    productPicture && fd.append("product_picture", productPicture);
    barcodeFile && fd.append("barcode_of_product", barcodeFile);
    moreInfoFile && fd.append("more_info_img", moreInfoFile);
    ingredientsFile && fd.append("ingredients_img", ingredientsFile);
    // category_image && fd.append("category_image", category_image);
    instructionsFile && fd.append("instructions_video", instructionsFile);
    fd.append("rich_long_description", description ?? "");
    fd.append("long_description", stripHtml(description) ?? "");
    fd.append("product_description", subtitle ?? "");
    // fd.append("category_description", category_description ?? "");
    fd.append(
      "categories",
      selectedCategories.length > 0
        ? JSON.stringify(selectedCategories.map((category) => category.id))
        : "[]"
    );
    fd.append("sub_category", selectedSubCategory?.value ?? "");
    fd.append("product_name", productName);
    fd.append("package_type", packageName ?? "");
    fd.append("price", parseFloat(salePrice).toFixed(2));
    fd.append("cost", parseFloat(productCost).toFixed(2));
    fd.append("shelf_life", shelfLife ?? "");
    fd.append("purchase_limit", purchaseLimit ?? "");
    fd.append("hopper_limit", hopperLimit ?? 1);
    // fd.append("heating_time", heating_time ?? "");
    fd.append("brand", selectedBrand?.value ?? "");
    fd.append("reported_category", selectedReportedCategory?.value ?? "");
    // fd.append("product_size", product_size);
    // fd.append("product_intro", product_intro);
    fd.append("status", selectedStatus ? selectedStatus?.value : "Enable");
    fd.append(
      "label_type_1",
      selectedLabelType1 ? selectedLabelType1?.value : ""
    );
    fd.append(
      "label_type_2",
      selectedLabelType2 ? selectedLabelType2?.value : ""
    );
    fd.append("label_title_1", labelTitle1 ?? "");
    fd.append("label_title_2", labelTitle2 ?? "");
    fd.append("variant_attribute_1", labelAttribute1 ?? "");
    fd.append("variant_attribute_2", labelAttribute2 ?? "");
    fd.append(
      "hex_code_1",
      selectedLabelType1?.value === "color" ? hexCode1 ?? "" : ""
    );
    fd.append(
      "hex_code_2",
      selectedLabelType2?.value === "color" ? hexCode2 ?? "" : ""
    );
    if (selectedLabelType1?.value !== "" || selectedLabelType2?.value !== "") {
      fd.append("variant_type", "generic_variant");
    } else {
      fd.append("variant_type", "default");
    }
    fd.append("product_sku", productSKU ?? "");
    // fd.append("product_type", product_type);
    fd.append("weight", weight ?? "");
    fd.append("operator", selectedOperator?.value ?? "");
    fd.append("age_restriction", selectedAgeRestriction?.value ?? "0");
    fd.append("is_recommended", recommendProduct ?? false);
    fd.append("product_tax", productTax ?? "0.0000");
    fd.append("hopper_limit", hopperLimit ?? 1);
    fd.append(
      "no_sale_days",
      (selectedDays &&
        selectedDays.length &&
        selectedDays.map((days) => days.value)) ||
        "[]"
    );
    selectedAgeRestriction?.value !== "0" &&
      sellingStartTime &&
      fd.append("selling_start_time", sellingStartTime ?? "");
    selectedAgeRestriction?.value !== "0" &&
      sellingEndTime &&
      fd.append("selling_end_time", sellingEndTime ?? "");
    let languageVariants = {};
    if (tableData) {
      tableData.forEach(
        (element) =>
          (languageVariants[element.language] = {
            product_name: element.product_name,
            product_description: element.product_description,
            long_description: element.long_description,
          })
      );
    }
    fd.append("language_variants", JSON.stringify(languageVariants) ?? {});
    setIsMutating(true);
    setCrudLoader(true);
    window.axiosIns
      .post(`/products`, fd)
      .then((res) => {
        setCrudLoader(false);
        enqueueSnackbar("Product Added successfully.");
        setTimeout(() => {
          setIsMutating(false);
        }, 200);
        handleClose();
        setDeviceList([]);
        getDeviceType();
        const newList = updateProductDropdownData(
          "add",
          {
            value: res.data.id,
            label: productName,
          },
          productsData
        );

        dispatch(setDropdownProducts(newList));
      })
      .catch((err) => {
        if (err.response.data.detail) {
          enqueueSnackbar(err.response.data.detail);
        } else {
          handleServerErrors(
            err,
            enqueueSnackbar,
            "Could not add product. Try again."
          );
        }
        setCrudLoader(false);
        setTableData([]);
        setIsMutating(false);
      });
  };

  const handleEdit = async () => {
    if (productName === "") {
      enqueueSnackbar("'Product Name' cannot be empty");
      return;
    }
    if (salePrice === "") {
      enqueueSnackbar("'Sale Price' cannot be empty");
      return;
    }
    if (
      (selectedCategories.some((category) => category.weight_limit > 0) ||
        selectedReportedCategory) &&
      !weight
    ) {
      enqueueSnackbar("'Weight' cannot be empty");
      return;
    }
    if (productCost === "") {
      enqueueSnackbar("'Product Cost' cannot be empty");
      return;
    }
    if (
      productNameError ||
      salePriceError ||
      productCostError ||
      purchaseLimitError ||
      weightError ||
      productTaxError ||
      hopperLimitError ||
      subtitleError
    ) {
      enqueueSnackbar("Please correct the highlighted errors");
      return;
    }
    if (
      subCategory &&
      subCategory["enable_product_selling_time"] &&
      selectedAgeRestriction.value !== "0"
    ) {
      if (!sellingStartTime && sellingEndTime) {
        enqueueSnackbar("'Start Time for Selling' cannot be empty");
        return;
      }
      if (sellingStartTime && !sellingEndTime) {
        enqueueSnackbar("'End Time for Selling' cannot be empty");
        return;
      }
    }

    if (subCategory && subCategory["enable_variant_management"]) {
      if (selectedLabelType1.value !== "") {
        if (labelTitle1 === "") {
          enqueueSnackbar("Please fill 'Label Title 1'");
          return;
        }
        if (labelAttribute1 === "") {
          enqueueSnackbar("Please fill 'Label Attribute 1'");
          return;
        }
        if (selectedLabelType1.value === "color") {
          if (hexCode1 === "") {
            enqueueSnackbar("Please fill 'Hex Code 1'");
            return;
          }
        }
      }

      if (selectedLabelType2.value !== "") {
        if (labelTitle2 === "") {
          enqueueSnackbar("Please fill 'Label Title 2'");
          return;
        }
        if (labelAttribute2 === "") {
          enqueueSnackbar("Please fill 'Label Attribute 2'");
          return;
        }
        if (selectedLabelType2.value === "color") {
          if (hexCode2 === "") {
            enqueueSnackbar("Please fill 'Hex Code 2'");
            return;
          }
        }
      }
    }

    if (instructionsFile && !isFileTypeValid(instructionsFile?.name)) {
      enqueueSnackbar("Please select a valid file for instruction video.");
      return;
    }

    const fd = new FormData();
    // send all five slots: File = new upload, URL string = keep existing, "" = cleared
    for (let i = 0; i < 5; i++) {
      const img = allImages[i];
      fd.append(
        `img${i + 1}`,
        img instanceof File ? img : typeof img === "string" ? img : ""
      );
    }
    instructionsFile &&
      instructionsFile.type &&
      fd.append("instructions_video", instructionsFile);
    productPicture &&
      productPicture.type &&
      fd.append("product_picture", productPicture);
    barcodeFile &&
      barcodeFile.type &&
      fd.append("barcode_of_product", barcodeFile);
    ingredientsFile &&
      ingredientsFile.type &&
      fd.append("ingredients_img", ingredientsFile);
    moreInfoFile &&
      moreInfoFile.type &&
      fd.append("more_info_img", moreInfoFile);
    fd.append("product_description", subtitle ?? "");
    fd.append("rich_long_description", description ?? "");
    fd.append("long_description", stripHtml(description) ?? "");
    fd.append(
      "categories",
      selectedCategories.length > 0
        ? JSON.stringify(selectedCategories.map((category) => category.id))
        : "[]"
    );
    fd.append("sub_category", selectedSubCategory?.value ?? "");
    fd.append("product_name", productName);
    fd.append("package_type", packageName ?? "");
    fd.append("price", parseFloat(salePrice).toFixed(2));
    fd.append("cost", parseFloat(productCost).toFixed(2));
    fd.append("shelf_life", shelfLife ?? "");
    fd.append("purchase_limit", purchaseLimit ?? "");
    if (hopperLimit == null){
      fd.append("hopper_limit", 1)
    }else{
    fd.append("hopper_limit", hopperLimit ?? 1);
    }
    // fd.append("replication", replication);
    // fd.append("heating_time", heating_time ?? "");
    fd.append("brand", selectedBrand?.value ?? "");
    fd.append("reported_category", selectedReportedCategory?.value ?? "");
    // fd.append("product_size", product_size);
    // fd.append("product_intro", product_intro);
    fd.append("status", selectedStatus ? selectedStatus?.value : "Enable");
    fd.append(
      "label_type_1",
      selectedLabelType1 ? selectedLabelType1?.value : ""
    );
    fd.append(
      "label_type_2",
      selectedLabelType2 ? selectedLabelType2?.value : ""
    );
    fd.append("label_title_1", labelTitle1 ?? "");
    fd.append("label_title_2", labelTitle2 ?? "");
    fd.append("variant_attribute_1", labelAttribute1 ?? "");
    fd.append("variant_attribute_2", labelAttribute2 ?? "");
    fd.append(
      "hex_code_1",
      selectedLabelType1?.value === "color" ? hexCode1 ?? "" : ""
    );
    fd.append(
      "hex_code_2",
      selectedLabelType2?.value === "color" ? hexCode2 ?? "" : ""
    );
    if (selectedLabelType1?.value !== "" || selectedLabelType2?.value !== "") {
      fd.append("variant_type", "generic_variant");
    } else {
      fd.append("variant_type", "default");
    }
    fd.append("product_sku", productSKU ?? "");
    // fd.append("product_type", product_type ?? "");
    fd.append("weight", weight ?? "");
    fd.append("operator", selectedOperator?.value ?? "");
    fd.append("age_restriction", selectedAgeRestriction?.value ?? "0");
    fd.append("is_recommended", recommendProduct ?? false);
    fd.append("product_tax", productTax ?? "0.0000");
    fd.append("hopper_limit", hopperLimit ?? 1);
    fd.append(
      "no_sale_days",
      (selectedDays &&
        selectedDays.length &&
        selectedDays.map((days) => days.value)) ||
        "[]"
    );
    selectedAgeRestriction?.value !== "0" &&
      sellingStartTime &&
      fd.append("selling_start_time", sellingStartTime ?? "");
    selectedAgeRestriction?.value !== "0" &&
      sellingEndTime &&
      fd.append("selling_end_time", sellingEndTime ?? "");
    let languageVariants = {};
    if (tableData) {
      tableData.forEach(
        (element) =>
          (languageVariants[element.language] = {
            product_name: element.product_name,
            product_description: element.product_description,
            long_description: element.long_description,
          })
      );
    }
    fd.append("language_variants", JSON.stringify(languageVariants) ?? {});
    const moduleId = modulesSelected[0].id;
    setIsMutating(true);
    setCrudLoader(true);
    window.axiosIns
      .patch(`/products/${moduleId}`, fd)
      .then(() => {
        setCrudLoader(false);
        enqueueSnackbar("Product edited successfully.");
        setTimeout(() => {
          setIsMutating(false);
        }, 200);
        handleClose();
        setDeviceList([]);
        getDeviceType();
        const newList = updateProductDropdownData(
          "edit",
          {
            value: moduleId,
            label: productName,
          },
          productsData
        );

        dispatch(setDropdownProducts(newList));
      })
      .catch((err) => {
        if (err.detail) {
          enqueueSnackbar(err.detail);
        } else if (((err.response || {}).data || {}).detail) {
          enqueueSnackbar(((err.response || {}).data || {}).detail);
        } else {
          handleServerErrors(
            err,
            enqueueSnackbar,
            "Could not edit product. Try again."
          );
        }
        setCrudLoader(false);
        setTableData([]);
        setIsMutating(false);
      });
  };

  const handleCategoryEdit = ({
    categories,
    brand,
    age_restriction,
    product_tax,
    no_sale_days,
    selling_start_time,
    selling_end_time,
    hopper_limit
  }) => {
    if (
      subCategory &&
      subCategory["enable_product_selling_time"] &&
      age_restriction !== "0"
    ) {
      if (!selling_start_time && selling_end_time) {
        enqueueSnackbar("'Start Time for Selling' cannot be empty");
        return;
      }
      if (selling_start_time && !selling_end_time) {
        enqueueSnackbar("'End Time for Selling' cannot be empty");
        return;
      }
    }
    const fd = new FormData();
    if(hopper_limit){
      fd.append("hopper_limit", hopper_limit);
    }
    fd.append("categories", categories ? JSON.stringify(categories) : "[]");
    fd.append("brand", brand ?? "");
    fd.append("age_restriction", age_restriction ?? "0");
    fd.append("product_tax", product_tax ?? "0.0000");
    fd.append(
      "no_sale_days",
      (no_sale_days && no_sale_days.length && no_sale_days) || "[]"
    );
    age_restriction !== "0" &&
      selling_start_time &&
      fd.append("selling_start_time", selling_start_time ?? "");
    age_restriction !== "0" &&
      selling_end_time &&
      fd.append("selling_end_time", selling_end_time ?? "");

    const moduleId = modulesSelected[0].id;

    setIsMutating(true);
    setCrudLoader(true);
    for (let i = 0; i < modulesSelected.length; i++) {
      window.axiosIns
        .patch(`/products/${modulesSelected[i].id}`, fd)
        .then(() => {
          setCategoryEditModal(false);
          setCrudLoader(false);
          if (i === modulesSelected.length - 1)
            enqueueSnackbar("Products were updated successfully.");
          setTimeout(() => {
            setIsMutating(false);
          }, 200);
        })
        .catch((err) => {
          if (err.detail) {
            enqueueSnackbar(err.detail);
          } else if (((err.response || {}).data || {}).detail) {
            enqueueSnackbar(((err.response || {}).data || {}).detail);
          } else {
            handleServerErrors(
              err,
              enqueueSnackbar,
              "Could not edit product. Please try again."
            );
          }
          setCategoryEditModal(false);
          setCrudLoader(false);
          setIsMutating(false);
        })
        .then(() => {
          setDeviceList([]);
          setModulesSelected([]);
          getDeviceType();
        });
    }
  };

  const handleFilter = (arr) => {
    setFilterable(arr);
    if (query !== "") {
      let searchFilter = handleMultiFilterSearch(filterLabels, arr, query);
      setup();
      setPage(0);
      window
        .axiosIns("/products", {
          params: {
            ...searchFilter,
            limit: rowsPerPage,
            ordering,
            variant: "products",
          },
        })
        .then((data = {}) => {
          handleRes(data.data);
        })
        .catch((err) => {
          setLoader(false);
        });
    }
  };

  const capitalizeFirstLetter = (word) =>
    word?.[0]?.toUpperCase() + word?.slice(1) || "";

  const productExport = () => {
    let params = {
      ...searchQuery,
      variant: "products",
      state: "all",
      tz: getTimeZoneDifference(),
    };

    let product_ids = modulesSelected.map((value) => value?.id);
    if (product_ids.length > 0) params["id"] = product_ids.join(",");

    window
      .axiosIns("/products/export", {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
        },
        params: params,
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Product-Summary-${moment().format("MM-DD-YYYY")}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => console.log(error));
  };

  const syncPlanogram = () => {
    setLoader(true);
    const fd = new FormData();
    window.axiosIns
      .post(`/planogram/sync_planograms`, fd)
      .then(() => {
        enqueueSnackbar("Planogram sync has been initiated. Changes will be reflected on all machines shortly.");
        setLoader(false);
      })
      .catch((err) => {
        if (err.response?.data?.detail) {
          enqueueSnackbar(err.response.data.detail);
          setLoader(false);
        } else {
          handleServerErrors(
            err,
            enqueueSnackbar,
            "Could not Sync product(s). Try again."
          );
          setLoader(false);
        }
      });
  };

  const changePage = async (url) => {
    setup();
    const { data } = await window.axiosIns(url);
    handleRes(data);
  };

  const handleSearch = (value) => {
    setQuery(value);
    let searchFilter = {};
    if (value !== "") {
      searchFilter = handleMultiFilterSearch(filterLabels, filterable, value);
    }
    setSearchQuery(searchFilter);
    setup();
    setPage(0);
    window
      .axiosIns("/products", {
        params: {
          ...searchFilter,
          limit: rowsPerPage,
          state: "all",
          variant: "products",
          ordering,
        },
      })
      .then((data = {}) => {
        handleRes(data.data);
      })
      .catch(() => {
        setLoader(false);
      });
  };

  const handleDelete = () => {
    const idsToDelete = modulesSelected.map((val) => val.id);
    const deletePromises = idsToDelete.map((id) =>
      window.axiosIns.delete(`/products/${id}`).catch((err) => {
        if (err.detail) {
          enqueueSnackbar(err.detail);
        } else if (err.response?.data?.detail) {
          enqueueSnackbar(err.response.data.detail);
        } else {
          handleServerErrors(
            err,
            enqueueSnackbar,
            "Could not delete product. Try again."
          );
        }
        return null;
      })
    );

    Promise.all(deletePromises).then(() => {
      const successfulDeletes = idsToDelete;
      const updatedDropdown = updateProductDropdownData(
        "delete",
        successfulDeletes.map((id) => ({ value: id })),
        productsData
      );

      dispatch(setDropdownProducts(updatedDropdown));
      setDeleteModal(false);

      if (deviceTypeList.length - modulesSelected.length === 0 && page > 0) {
        setPage(page - 1);
        changePage(previousPage);
      } else {
        getDeviceType();
      }

      enqueueSnackbar("Product(s) deleted successfully.");
    });
  };

  const calculateImageMaxHeight = () => {
    let height = 448;
    if (
      showTimePeriod &&
      subCategory &&
      subCategory["enable_product_selling_time"]
    ) {
      height += 56;
    }
    if (
      subCategory["enable_subcategory"] ||
      subCategory["enable_taxes_per_product"]
    ) {
      height += 56;
    }
    return height + "px";
  };

  const handleForceDelete = () => {
    modulesSelected.forEach((val, index) => {
      const params = {
        force: "true",
      };
      window.axiosIns
        .delete(`/products/${val.id}`, { params })
        .then(() => {
          setDeleteModal(false);
          setForceDeleteModal(false);
          if (modulesSelected.length === index + 1) {
            if (
              deviceTypeList.length - modulesSelected.length === 0 &&
              page > 0
            ) {
              setPage(page - 1);
              changePage(previousPage);
            } else {
              getDeviceType();
            }
            enqueueSnackbar("Product deleted successfully.");
          }
        })
        .catch((err) => {
          if (err.detail) {
            enqueueSnackbar(err.detail);
          } else if (err.response.data.detail) {
            enqueueSnackbar(err.response.data.detail);
          } else {
            handleServerErrors(
              err,
              enqueueSnackbar,
              "Could not delete product. Try again."
            );
          }
        });
    });
  };

  const handleClose = () => {
    setOpenProductModal(false);
    setModulesSelected([]);
    setTableData([]);
    setShowTimePeriod(false);
    setProductName("");
    setProductNameError("");
    setPackageName("");
    setProductSKU("");
    setSelectedCategories([]);
    setCategorySearchQuery("");
    setSelectedDays([]);
    setSelectedBrand(null);
    setSelectedReportedCategory(null);
    setSelectedOperator(null);
    setSelectedStatus({
      label: "Enable",
      value: "Enable",
    });
    setSelectedLabelType1({
      label: "",
      value: "",
    });
    setSelectedLabelType2({
      label: "",
      value: "",
    });
    setLabelTitle1("");
    setLabelTitle2("");
    setLabelAttribute1("");
    setLabelAttribute2("");
    setHexCode1("#000000");
    setHexCode2("#000000");
    setSelectedAgeRestriction({
      label: "Not Required",
      value: "0",
    });
    setSelectedSubCategory(null);
    setSalePrice("");
    setSalePriceError("");
    setProductCost("");
    setProductCostError("");
    setSellingStartTime("00:00");
    setSellingEndTime("00:00");
    setPurchaseLimit("");
    setPurchaseLimitError("");
    setShelfLife("");
    setWeight("");
    setWeightError("");
    setProductTax("0.0000");
    setProductTaxError("");
    setHopperLimit(1);
    setHopperLimitError("");
    setSubtitle("");
    setSubtitleError("");
    setDescription("");
    setNumberOfFiles(0);
    setImagesData(null);
    setAllImages([]);
    setBarcodeFile(null);
    setBarcodeFileName("");
    setProductPicture(null);
    setProductPictureName("");
    setMoreInfoFile(null);
    setMoreInfoFileName("");
    setIngredientsFile(null);
    setIngredientsFileName("");
    setInstructionsFile(null);
    setInstructionsFileName("");
    setRecommendProduct(false);
    setCheckExtension({
      product_picture: true,
      barcode: true,
      more_info: true,
      ingredients: true,
      instructions_video: true,
    });
  };

  const handleClick = (event) => {
    hiddenFileInput.current.value = null;
    hiddenFileInput.current.click();
  };
  // Call a function (passed as a prop from the parent component)
  // to handle the user-selected file
  const handleChange = async (event) => {
    const fileUploaded = event.target.files[0];
    const formData = new FormData();
    formData.append("template", fileUploaded);

    setIsMutating(true);
    window.axiosIns
      .post(`/products/import`, formData)
      .then((resp) => {
        const {
          data: { data },
        } = resp;
        const errors = [];
        if (data.records_failed > 0) {
          Object.keys(data.failed_entries).forEach((key) => {
            errors.push(`Row ${key} : ${data.failed_entries[key]}`);
          });

          setImportError(errors);
          setIsInfo(true);
        }
        enqueueSnackbar(resp?.data?.message || "Products Added successfully.", {
          autoHideDuration: 3000,
        });
        setTimeout(() => {
          setIsMutating(false);
        }, 200);
      })
      .catch((err) => {
        if (err?.response?.data?.detail) {
          enqueueSnackbar(err.response.data.detail);
        } else {
          handleServerErrors(
            err,
            enqueueSnackbar,
            "Could not add product. Try again."
          );
        }
        setIsMutating(false);
      })
      .then(() => {
        getDeviceType();
        setModulesSelected([]);
      });
  };

  const hiddenFileInput = React.useRef(null);

  return (
    <div id="sa-modules-wrapper" className={classes.wrapper}>
      <ContentHeader
        description="
        All Products are listed here. You can create a new product that will be sold in a Vending Machine."
      />
      <div className={classes.toolbar}>
        <div className={classes.crudButtons}>
          <AddButton
            className="mr-3"
            label="Add"
            onClick={() => {
              setModulesSelected([]);
              setShowTimePeriod(false);
              setOpenProductModal(true);
            }}
            disabled={current_user.type === "SU" || loader}
          />
          <EditButton
            disabled={
              modulesSelected.length === 0 ||
              current_user.type === "SU" ||
              loader
            }
            className="mr-3"
            label="Edit"
            onClick={async () => {
              if (modulesSelected.length > 1) {
                setCategoryEditModal(true);
              } else {
                const row = modulesSelected[0];
                if (row?.age_restriction == 0) {
                  setShowTimePeriod(false);
                } else {
                  setShowTimePeriod(true);
                }
                setSelectedAgeRestriction(
                  AGE_RESTRICTION_VALUES.find(
                    (age) => age.value === row?.age_restriction
                  )
                );
                setBarcodeFile(row?.barcode_of_product);
                const selectedReportedCategory = reportedCategoryList.find(
                  (category) => category.id === row?.reported_category
                );
                setSelectedReportedCategory(
                  selectedReportedCategory
                    ? {
                        label: selectedReportedCategory.category_name,
                        value: selectedReportedCategory.id,
                      }
                    : null
                );
                const selectedBrand = brandList.find(
                  (brand) => brand.id === row?.brand
                );
                setSelectedBrand(
                  selectedBrand
                    ? {
                        label: selectedBrand.brand,
                        value: selectedBrand.id,
                      }
                    : null
                );
                setSelectedCategories(
                  categoryList.filter((category) =>
                    row?.categories.includes(category.id)
                  )
                );
                setProductCost(currencyFormatter(row?.cost));
                setNumberOfFiles(row?.images.length);
                // [src, name] pairs — modal only shows the remove icon for pair entries
                setImagesData(
                  (row?.images || []).map((u) => [
                    u,
                    u.split("/").pop().split("?")[0],
                  ])
                );
                // track existing image URLs so remove/append operate on the full set
                setAllImages(row?.images || []);
                setProductPicture(row?.product_picture);
                setIngredientsFile(row?.ingredients_img);
                setMoreInfoFile(row?.more_info_img);
                setInstructionsFile(row?.instructions_video);
                setRecommendProduct(row?.is_recommended);
                setDescription(
                  row?.rich_long_description || row?.long_description || ""
                );
                const selectedDays =
                  row?.no_sale_days[0] === "[]"
                    ? []
                    : NO_SALE_DAYS.filter((day) =>
                        row?.no_sale_days.includes(day.value)
                      );
                setSelectedDays(selectedDays);
                const selectedOperator = operatorsData.find(
                  (operator) => operator.value === row?.operator
                );
                setSelectedOperator(
                  selectedOperator
                    ? {
                        label: `${selectedOperator.label} || (${selectedOperator.customer_type})`,
                        value: selectedOperator.value,
                      }
                    : null
                );
                setPackageName(row?.package_type);
                setSalePrice(currencyFormatter(row?.price));
                setSubtitle(row?.product_description);
                setProductName(row?.product_name);
                setProductSKU(row?.product_sku);
                setProductTax(taxFormatter(row?.product_tax));
                setHopperLimit(row?.hopper_limit);
                setPurchaseLimit(row?.purchase_limit);
                setSellingStartTime(row?.selling_start_time);
                setSellingEndTime(row?.selling_end_time);
                setShelfLife(row?.shelf_life);
                setSelectedStatus({ label: row?.status, value: row?.status });
                setSelectedLabelType1({
                  label: row?.label_type_1
                    ? capitalizeFirstLetter(row?.label_type_1)
                    : "",
                  value: row?.label_type_1 || "",
                });
                setSelectedLabelType2({
                  label: row?.label_type_2
                    ? capitalizeFirstLetter(row?.label_type_2)
                    : "",
                  value: row?.label_type_2 || "",
                });
                setLabelTitle1(row?.label_title_1);
                setLabelTitle2(row?.label_title_2);
                setLabelAttribute1(row?.variant_attribute_1);
                setLabelAttribute2(row?.variant_attribute_2);
                setHexCode1(row?.hex_code_1);
                setHexCode2(row?.hex_code_2);
                const selectedSubCategory = categoryList
                  .filter((data) => data.is_subcategory)
                  .find((x) => x.id === row?.sub_category);
                setSelectedSubCategory(
                  selectedSubCategory
                    ? {
                        label: selectedSubCategory.category_name,
                        value: selectedSubCategory.id,
                      }
                    : null
                );
                setWeight(row?.weight);
                setTableData(row?.language_variants);
                setOpenProductModal(true);
              }
            }}
          />
          <DeleteButton
            disabled={
              modulesSelected.length === 0 ||
              current_user.type === "SU" ||
              loader
            }
            className="mr-3"
            label="Delete"
            onClick={() => setDeleteModal(true)}
          />
          {current_user.type !== "SU" && (
            <>
              <DeployButton
                disabled={loader}
                className="mr-3"
                label="Sync"
                onClick={() => syncPlanogram()}
              />
              <ExportButton
                disabled={loader}
                className="mr-3"
                label="Export"
                onClick={() => productExport()}
              />
              <ImportButton
                disabled={current_user.type === "SU" || loader}
                className="mr-3"
                label="Import"
                onClick={handleClick}
              />
              <input
                type="file"
                ref={hiddenFileInput}
                onChange={handleChange}
                style={{ display: "none" }}
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              />
            </>
          )}
        </div>
        <div className="d-flex">
          <SearchBox
            placeholder="Search"
            multiple={true}
            query={query}
            onChange={handleFilter}
            fields={deviceTypeFields}
            selectedFields={filterable}
            handleSearch={handleSearch}
          />
        </div>
      </div>
      <div className={classes.content}>
        <TableGenerator
          searchQuery={query}
          initialSort={"product_sku"}
          searchColumnsFilter={true}
          fields={_flatten(fields)}
          loader={loader}
          data={deviceTypeList}
          currentPage={page}
          handleSortChange={(ordering) => {
            setOrdering(ordering);
            getDeviceType(sortLabels[ordering] ?? ordering);
          }}
          onPageChange={(page, direction) => {
            setPage(page);
            if (direction === "next") {
              changePage(nextPage);
            } else if (direction === "back") {
              changePage(previousPage);
            } else if (direction === "first") {
              changePage(firstPage);
            } else if (direction === "last") {
              changePage(lastPage);
            }
          }}
          backendPagination={true}
          onRowPerPageChange={(rows) => {
            getDeviceType(null, rows, 0);
            setRowsPerPage(rows);
            setPage(0);
          }}
          dataCount={dataCount}
          selectedRecords={modulesSelected}
          rowOnePage={10}
          onChangeSelected={(modulesSelected) =>
            setModulesSelected(modulesSelected)
          }
        />
        <Dialog
          open={openProductModal}
          onClose={handleClose}
          maxWidth="lg"
          fullWidth={true}
          style={{ display: "block" }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <Loader visible={crudLoader} />
          <DialogContent>
            <Grid container>
              <Grid xs={6}>
                <DialogTitle style={{ padding: "0" }}>
                  {modulesSelected.length === 0
                    ? "Add Product"
                    : "Edit Product"}
                </DialogTitle>
                <DialogContentText>
                  {modulesSelected.length === 0
                    ? "Please fill in the details below."
                    : "Please edit the details below."}
                </DialogContentText>
              </Grid>
            </Grid>
            <Grid
              container
              spacing={2}
              style={{
                padding: "16px 0",
              }}
            >
              <Grid container spacing={2} xs={6}>
                <Grid xs={12}>
                  <TextField
                    type="text"
                    variant="outlined"
                    size="small"
                    required={true}
                    label="Product Name"
                    value={productName}
                    error={!!productNameError}
                    helperText={productNameError || ""}
                    onChange={(e) => setProductName(e.target.value)}
                    onBlur={(e) => {
                      setProductName(e.target.value?.trim());
                      setProductNameError(validateProductName(e.target.value));
                    }}
                    style={{ width: "100%" }}
                  />
                </Grid>
                <Grid xs={12}>
                  <Autocomplete
                    multiple
                    size="small"
                    options={filteredCategories}
                    getOptionLabel={(option) => option.category_name}
                    value={selectedCategories}
                    disableCloseOnSelect
                    limitTags={2}
                    onChange={(e, val, reason) => {
                      if (
                        subCategory &&
                        subCategory.enable_weight_limit &&
                        val.length > 1
                      ) {
                        // Prevent multiple selection when your condition is true
                        return;
                      }
                      setSelectedCategories(val);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Product Categories"
                        placeholder={
                          selectedCategories.length ? "" : "Search categories"
                        }
                        onChange={(e) => setCategorySearchQuery(e.target.value)}
                      />
                    )}
                    renderTags={(tagValue, getTagProps) =>
                      tagValue.map((option, index) => {
              const { key, ...tp } = getTagProps({ index });
              return (
                <Chip key={key}
                          key={option.id}
                          label={option.category_name}
                          {...tp}
                        />
              );
            })
                    }
                  />
                </Grid>
                <Grid xs={6}>
                  <Autocomplete
                    id="combo-box-demo"
                    size="small"
                    options={
                      brandList.length
                        ? [
                            ...brandList.map((x) => ({
                              label: x.brand,
                              value: x.id,
                            })),
                          ]
                        : [{ label: "", value: "" }]
                    }
                    style={{ display: "block" }}
                    value={selectedBrand}
                    onChange={(_, val) => setSelectedBrand(val)}
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                    getOptionLabel={(option) => option?.label || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        style={{ width: "100%" }}
                        label="Product Brand"
                        variant="outlined"
                      />
                    )}
                  />
                </Grid>
                {getComponents(1)}
                <Grid xs={6}>
                  <TextField
                    type="text"
                    variant="outlined"
                    size="small"
                    label="Product SKU"
                    value={productSKU}
                    onChange={(e) => setProductSKU(e.target.value)}
                    onBlur={(e) => {
                      setProductSKU(e.target.value?.trim());
                    }}
                    style={{ width: "100%" }}
                  />
                </Grid>
                {getComponents(4)}
                <Grid xs={6}>
                  <TextField
                    type="number"
                    variant="outlined"
                    onWheel={(event) => event.target.blur()}
                    size="small"
                    label="Sale Price ($)"
                    required={true}
                    value={salePrice}
                    error={!!salePriceError}
                    helperText={salePriceError || ""}
                    onChange={(e) => setSalePrice(e.target.value)}
                    onBlur={(e) => {
                      setSalePrice(e.target.value?.trim());
                      setSalePriceError(validateSalePrice(e.target.value));
                    }}
                    style={{ width: "100%" }}
                  />
                </Grid>
                <Grid xs={6}>
                  <TextField
                    type="number"
                    variant="outlined"
                    onWheel={(event) => event.target.blur()}
                    size="small"
                    label="Product Cost ($)"
                    required={true}
                    value={productCost}
                    error={!!productCostError}
                    helperText={productCostError || ""}
                    onChange={(e) => setProductCost(e.target.value)}
                    onBlur={(e) => {
                      setProductCost(e.target.value?.trim());
                      setProductCostError(validateProductCost(e.target.value));
                    }}
                    style={{ width: "100%" }}
                  />
                </Grid>
                {showTimePeriod &&
                  subCategory &&
                  subCategory["enable_product_selling_time"] && (
                    <>
                      <Grid xs={6}>
                        <TextField
                          type="time"
                          size="small"
                          label="Selling Start Time"
                          value={sellingStartTime ? sellingStartTime : "00:00"}
                          variant="outlined"
                          fullWidth
                          onChange={(e) =>
                            handleTimeChange(
                              e.target.value,
                              setSellingStartTime
                            )
                          }
                          slotProps={{ inputLabel: { shrink: true }, input: {
                            endAdornment: sellingStartTime && (
                              <IconButton
                                onClick={() =>
                                  handleTimeChange("00:00", setSellingStartTime)
                                }
                                size="small"
                              >
                                <ClearIcon />
                              </IconButton>
                            ),
                          } }}
                        />
                      </Grid>
                      <Grid xs={6}>
                        <TextField
                          type="time"
                          size="small"
                          label="Selling End Time"
                          value={sellingEndTime ? sellingEndTime : "00:00"}
                          variant="outlined"
                          fullWidth
                          onChange={(e) =>
                            handleTimeChange(e.target.value, setSellingEndTime)
                          }
                          slotProps={{ inputLabel: { shrink: true }, input: {
                            endAdornment: sellingEndTime && (
                              <IconButton
                                onClick={() =>
                                  handleTimeChange("00:00", setSellingEndTime)
                                }
                                size="small"
                              >
                                <ClearIcon />
                              </IconButton>
                            ),
                          } }}
                        />
                      </Grid>
                    </>
                  )}
                <Grid xs={6}>
                  <TextField
                    type="number"
                    variant="outlined"
                    onWheel={(event) => event.target.blur()}
                    size="small"
                    label="Purchase Limit"
                    value={purchaseLimit}
                    error={!!purchaseLimitError}
                    helperText={purchaseLimitError || ""}
                    onChange={(e) => setPurchaseLimit(e.target.value)}
                    onBlur={(e) => {
                      setPurchaseLimit(e.target.value?.trim());
                      setPurchaseLimitError(
                        validatePurchaseLimit(e.target.value)
                      );
                    }}
                    style={{ width: "100%" }}
                  />
                </Grid>
                <Grid xs={6}>
                  <TextField
                    type="number"
                    variant="outlined"
                    onWheel={(event) => event.target.blur()}
                    size="small"
                    label="Shelf life (days)"
                    value={shelfLife}
                    onChange={(e) => setShelfLife(e.target.value)}
                    onBlur={(e) => {
                      setShelfLife(e.target.value?.trim());
                    }}
                    style={{ width: "100%" }}
                  />
                </Grid>
                <Grid xs={6}>
                  <TextField
                    type="text"
                    variant="outlined"
                    size="small"
                    label="Weight (in grams)"
                    value={weight}
                    required={
                      selectedCategories.some(
                        (c) => Number(c.weight_limit) > 0
                      ) || selectedReportedCategory
                    }
                    error={!!weightError}
                    helperText={weightError || ""}
                    onChange={(e) => setWeight(e.target.value)}
                    onBlur={(e) => {
                      setWeight(e.target.value?.trim());
                      setWeightError(validateWeight(e.target.value));
                    }}
                    style={{ width: "100%" }}
                  />
                </Grid>
                <Grid xs={6}>
                  <Autocomplete
                    id="combo-box-demo"
                    size="small"
                    options={[
                      { label: "Enable", value: "Enable" },
                      { label: "Disable", value: "Disable" },
                    ]}
                    style={{ display: "block" }}
                    value={selectedStatus}
                    onChange={(_, val) => setSelectedStatus(val)}
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                    getOptionLabel={(option) => option?.label || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        required={true}
                        style={{ width: "100%" }}
                        label="Status"
                        variant="outlined"
                      />
                    )}
                  />
                </Grid>
                {getComponents(2)}
                {subCategory && subCategory["enable_taxes_per_product"] && (
                  <Grid xs={6}>
                    <TextField
                      type="text"
                      variant="outlined"
                      size="small"
                      label="Tax (%)"
                      value={productTax}
                      error={!!productTaxError}
                      helperText={productTaxError || ""}
                      onChange={(e) => setProductTax(e.target.value)}
                      onBlur={(e) => {
                        setProductTax(e.target.value?.trim());
                        setProductTaxError(validateTax(e.target.value));
                      }}
                      style={{ width: "100%" }}
                    />
                  </Grid>
                )}
                {subCategory && subCategory["enable_multi_pickup"] && (
                  <Grid xs={6}>
                    <TextField
                      type="number"
                      variant="outlined"
                      size="small"
                      label="Hopper Limit"
                      value={hopperLimit}
                      error={!!hopperLimitError}
                      helperText={hopperLimitError || ""}
                      onChange={(e) => setHopperLimit(e.target.value)}
                      onBlur={(e) => {
                        let finalValue = e.target.value;
                        
                        if (finalValue.trim() === "") {
                          finalValue = "1";
                        }
                        
                        setHopperLimit(finalValue);
                        setHopperLimitError(validateHopperLimit(finalValue));
                      }}
                      slotProps={{ inputLabel: { shrink: hopperLimit !== "" && hopperLimit !== null ? true : undefined, } }}
                      style={{ width: "100%" }}
                    />
                  </Grid>
                )}
                {getComponents(5)}
                {getComponents(3)}
                <Grid xs={12}>
                  <Autocomplete
                    multiple
                    size="small"
                    options={NO_SALE_DAYS}
                    getOptionLabel={(option) => option?.label || ""}
                    value={selectedDays}
                    disableCloseOnSelect
                    limitTags={4}
                    onChange={(e, val) => setSelectedDays(val)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="No Sale Days"
                        placeholder={selectedDays.length ? "" : "Select days"}
                      />
                    )}
                    renderTags={(tagValue, getTagProps) =>
                      tagValue.map((option, index) => {
              const { key, ...tp } = getTagProps({ index });
              return (
                <Chip key={key}
                          key={option.value}
                          label={option.label}
                          {...tp}
                        />
              );
            })
                    }
                  />
                </Grid>
              </Grid>
              <Grid container xs={6}>
                {productPicture ? (
                  <div
                    style={{
                      position: "relative",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                      maxHeight: calculateImageMaxHeight(),
                      width: "100%",
                      padding: "8px 0",
                      marginLeft: "16px",
                      borderRadius: 5,
                      background: "#f3f3f3",
                      border: "1px solid #ccc",
                    }}
                  >
                    <IconButton
                      color="primary"
                      variant="outlined"
                      onClick={() => {
                        setProductPicture(null);
                        setProductPictureName("");
                      }}
                      style={{
                        width: "8px",
                        height: "8px",
                        position: "absolute",
                        top: -15,
                        right: -15,
                      }}
                      size="large">
                      <DeleteIcon />
                    </IconButton>
                    <img
                      style={{
                        objectFit: "contain",
                        width: "100%",
                        height: "100%",
                      }}
                      src={getImageSrc(productPicture)}
                      alt="Preview Image"
                    />
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                      width: "100%",
                      marginLeft: "16px",
                      border: "5px dashed #e2e2e2",
                      borderRadius: 5,
                    }}
                  >
                    <div>
                      <FileUploadButton
                        size="small"
                        value={productPicture}
                        onChange={(e) =>
                          handleFileChange(
                            e,
                            setProductPictureName,
                            setProductPicture,
                            "product_picture"
                          )
                        }
                        tabIndex="19"
                        uploaded={productPictureName !== ""}
                        label="Product Picture"
                        style={{ whiteSpace: "nowrap" }}
                        className="mr-2"
                      />
                      <label
                        style={{
                          fontSize: 13,
                          display: "block",
                          color: "#858585",
                        }}
                      >
                        Suggested file types: png, jpg, jpeg, gif
                      </label>
                      {checkExtension?.product_picture ? (
                        <div
                          style={{
                            fontSize: 11,
                            maxWidth: 200,
                            overflowWrap: "break-word",
                            marginTop: 5,
                          }}
                        >
                          {productPictureName}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                )}
              </Grid>
            </Grid>
            <Grid
              container
              spacing={2}
              style={{
                padding: "8px 0px",
              }}
            >
              <Grid container spacing={2} xs={12}>
                <Grid xs={12}>
                  <TextField
                    type="text"
                    variant="outlined"
                    size="small"
                    label="Subtitle"
                    value={subtitle}
                    error={!!subtitleError}
                    helperText={subtitleError || ""}
                    onChange={(e) => setSubtitle(e.target.value)}
                    onBlur={(e) => {
                      setSubtitle(e.target.value?.trim());
                      setSubtitleError(validateSubtitle(e.target.value));
                    }}
                    style={{ width: "100%" }}
                  />
                </Grid>
                <Grid xs={12}>
                  <RichTextEditor
                    description={description}
                    setDescription={setDescription}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                spacing={2}
                xs={12}
                wrap="nowrap"
                style={{
                  padding: "16px 0px 0px",
                }}
              >
                <Grid xs={12 / 5}>
                  <div>
                    <FileUploadInfoButton
                      tabIndex="20"
                      uploaded={numberOfFiles !== "" && numberOfFiles !== 0}
                      size="small"
                      label="Additional Images"
                      style={{ whiteSpace: "nowrap" }}
                      open={() => setOpenAddlImagesModal(true)}
                      value={imagesData}
                      className="mr-2"
                    />
                    <label
                      style={{
                        fontSize: 13,
                        display: "block",
                        color: "#858585",
                      }}
                    >
                      Suggested file types: png, jpg, jpeg, gif
                    </label>
                    <div
                      style={{
                        fontSize: 11,
                        maxWidth: 200,
                        overflowWrap: "break-word",
                        marginTop: 5,
                      }}
                    >
                      {numberOfFiles
                        ? Number(numberOfFiles) > 1
                          ? `${numberOfFiles} Files uploaded successfully`
                          : `${numberOfFiles} File uploaded successfully`
                        : ""}
                    </div>
                  </div>
                  <ImagesModal
                    title="ADDITIONAL IMAGES"
                    data={imagesData || []}
                    imagesData={allImages}
                    open={openAddlImagesModal}
                    close={() => setOpenAddlImagesModal(false)}
                    // field={field}
                    onChange={() => {}}
                    fieldValues={{ images: imagesData }}
                    getImages={getImages}
                    removeImages={removeImages}
                    info={true}
                    changeIcon={false}
                  />
                </Grid>
                {subCategory && subCategory["enable_barcode"] && (
                  <Grid xs={12 / 5}>
                    <FileUploadButton
                      size="small"
                      value={barcodeFile}
                      onChange={(e) =>
                        handleFileChange(
                          e,
                          setBarcodeFileName,
                          setBarcodeFile,
                          "barcode"
                        )
                      }
                      tabIndex="19"
                      uploaded={barcodeFileName !== ""}
                      label={
                        subCategory && subCategory["change_barcode_to_desc_img"]
                          ? "Description Image"
                          : "BarCode"
                      }
                      style={{ whiteSpace: "nowrap" }}
                      className="mr-2"
                    />
                    <label
                      style={{
                        fontSize: 13,
                        display: "block",
                        color: "#858585",
                      }}
                    >
                      Suggested file types: png, jpg, jpeg, gif
                    </label>
                    {checkExtension?.barcode ? (
                      <div
                        style={{
                          fontSize: 11,
                          maxWidth: 200,
                          overflowWrap: "break-word",
                          marginTop: 5,
                        }}
                      >
                        {barcodeFileName}
                      </div>
                    ) : (
                      ""
                    )}
                  </Grid>
                )}
                {subCategory && subCategory["enable_info_img"] && (
                  <Grid xs={12 / 5}>
                    <FileUploadButton
                      size="small"
                      value={moreInfoFile}
                      onChange={(e) =>
                        handleFileChange(
                          e,
                          setMoreInfoFileName,
                          setMoreInfoFile,
                          "more_info"
                        )
                      }
                      tabIndex="20"
                      uploaded={moreInfoFileName !== ""}
                      label="More Info"
                      style={{ whiteSpace: "nowrap" }}
                      className="mr-2"
                    />
                    <label
                      style={{
                        fontSize: 13,
                        display: "block",
                        color: "#858585",
                      }}
                    >
                      Suggested file types: png, jpg, jpeg, gif
                    </label>
                    {checkExtension.more_info ? (
                      <div
                        style={{
                          fontSize: 11,
                          maxWidth: 200,
                          overflowWrap: "break-word",
                          marginTop: 5,
                        }}
                      >
                        {moreInfoFileName}
                      </div>
                    ) : (
                      ""
                    )}
                  </Grid>
                )}
                {subCategory && subCategory["enable_ingredient_img"] && (
                  <Grid xs={12 / 5}>
                    <FileUploadButton
                      size="small"
                      value={ingredientsFile}
                      onChange={(e) =>
                        handleFileChange(
                          e,
                          setIngredientsFileName,
                          setIngredientsFile,
                          "ingredients"
                        )
                      }
                      tabIndex="20"
                      uploaded={ingredientsFileName !== ""}
                      label="Ingredients"
                      style={{ whiteSpace: "nowrap" }}
                      className="mr-2"
                    />
                    <label
                      style={{
                        fontSize: 13,
                        display: "block",
                        color: "#858585",
                      }}
                    >
                      Suggested file types: png, jpg, jpeg, gif
                    </label>
                    {checkExtension.ingredients ? (
                      <div
                        style={{
                          fontSize: 11,
                          maxWidth: 200,
                          overflowWrap: "break-word",
                          marginTop: 5,
                        }}
                      >
                        {ingredientsFileName}
                      </div>
                    ) : (
                      ""
                    )}
                  </Grid>
                )}
                {subCategory && subCategory["enable_video_description"] && (
                  <Grid xs={12 / 5}>
                    <VideoUploadButton
                      size="small"
                      value={instructionsFile}
                      onChange={(e) =>
                        handleFileChange(
                          e,
                          setInstructionsFileName,
                          setInstructionsFile,
                          "instructions_video",
                          false
                        )
                      }
                      tabIndex="22"
                      uploaded={instructionsFileName !== ""}
                      label="Instructions Video"
                      style={{ whiteSpace: "nowrap" }}
                      className="mr-2"
                    />
                    <label
                      style={{
                        fontSize: 13,
                        display: "block",
                        color: "#858585",
                      }}
                    >
                      Suggested file types: .MOV,.MP4
                    </label>
                    {checkExtension.instructions_video ? (
                      <div
                        style={{
                          fontSize: 11,
                          maxWidth: 200,
                          overflowWrap: "break-word",
                          marginTop: 5,
                        }}
                      >
                        {instructionsFileName}
                      </div>
                    ) : (
                      ""
                    )}
                  </Grid>
                )}
              </Grid>

              {subCategory && subCategory["enable_variant_management"] && (
                <>
                  <Grid
                    container
                    spacing={2}
                    xs={12}
                    alignItems="flex-end"
                    style={{ paddingTop: "8px" }}
                  >
                    <Grid xs={3}>
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <span
                          style={{ color: "#858585", padding: "0 0 8px 4px" }}
                        >
                          Label 1
                        </span>
                        <Autocomplete
                          id="combo-box-demo"
                          size="small"
                          options={[
                            { label: "", value: "" },
                            { label: "Color", value: "color" },
                            { label: "Size", value: "size" },
                            { label: "Custom", value: "custom" },
                          ]}
                          style={{ display: "block" }}
                          value={selectedLabelType1}
                          onChange={(_, val, reason) => {
                            if (reason === "clear") {
                              setSelectedLabelType1({ label: "", value: "" });
                              setLabelTitle1("");
                              setLabelAttribute1("");
                              return;
                            }
                            if (val.value === "color") {
                              setHexCode1("#000000");
                            }
                            setSelectedLabelType1(val);
                          }}
                          isOptionEqualToValue={(option, value) =>
                            option.value === value.value
                          }
                          getOptionLabel={(option) => option?.label || ""}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              style={{ width: "100%" }}
                              label="Type of label"
                              variant="outlined"
                            />
                          )}
                        />
                      </div>
                    </Grid>
                    <Grid xs={3}>
                      <TextField
                        type="text"
                        variant="outlined"
                        size="small"
                        label="Label Title"
                        value={labelTitle1}
                        required={selectedLabelType1 !== ""}
                        onChange={(e) => setLabelTitle1(e.target.value)}
                        onBlur={(e) => {
                          setLabelTitle1(e.target.value?.trim());
                        }}
                        style={{ width: "100%" }}
                        disabled={selectedLabelType1.value === ""}
                        slotProps={{ inputLabel: { style: { zIndex: 0 }, } }}
                      />
                    </Grid>
                    <Grid xs={3}>
                      <TextField
                        type="text"
                        variant="outlined"
                        size="small"
                        label="Attribute"
                        value={labelAttribute1}
                        required={selectedLabelType1 !== ""}
                        onChange={(e) => setLabelAttribute1(e.target.value)}
                        onBlur={(e) => {
                          setLabelAttribute1(e.target.value?.trim());
                        }}
                        style={{ width: "100%" }}
                        disabled={selectedLabelType1.value === ""}
                      />
                    </Grid>
                    {selectedLabelType1.value === "color" && (
                      <Grid xs={3}>
                        <TextField
                          type="color"
                          variant="outlined"
                          size="small"
                          label="Hex Color"
                          value={hexCode1}
                          required={selectedLabelType1 !== ""}
                          onChange={(e) => setHexCode1(e.target.value)}
                          onBlur={(e) => {
                            setHexCode1(e.target.value?.trim());
                          }}
                          style={{ width: "100%" }}
                          disabled={selectedLabelType1.value === ""}
                        />
                      </Grid>
                    )}
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    xs={12}
                    alignItems="flex-end"
                    style={{ paddingTop: "8px" }}
                  >
                    <Grid xs={3}>
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <span
                          style={{ color: "#858585", padding: "0 0 8px 4px" }}
                        >
                          Label 2
                        </span>
                        <Autocomplete
                          id="combo-box-demo"
                          size="small"
                          disabled={
                            modulesSelected[0]?.has_variants &&
                            selectedLabelType2.value == ""
                          }
                          options={[
                            { label: "", value: "" },
                            { label: "Color", value: "color" },
                            { label: "Size", value: "size" },
                            { label: "Custom", value: "custom" },
                          ]}
                          style={{ display: "block" }}
                          value={selectedLabelType2}
                          onChange={(_, val, reason) => {
                            if (reason === "clear") {
                              setSelectedLabelType2({ label: "", value: "" });
                              setLabelTitle2("");
                              setLabelAttribute2("");
                              return;
                            }
                            if (val.value === "color") {
                              setHexCode2("#000000");
                            }
                            setSelectedLabelType2(val);
                          }}
                          isOptionEqualToValue={(option, value) =>
                            option.value === value.value
                          }
                          getOptionLabel={(option) => option?.label || ""}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              style={{ width: "100%" }}
                              label="Type of label"
                              variant="outlined"
                            />
                          )}
                        />
                      </div>
                    </Grid>
                    <Grid xs={3}>
                      <TextField
                        type="text"
                        variant="outlined"
                        size="small"
                        label="Label Title"
                        value={labelTitle2}
                        required={selectedLabelType2 !== ""}
                        onChange={(e) => setLabelTitle2(e.target.value)}
                        onBlur={(e) => {
                          setLabelTitle2(e.target.value?.trim());
                        }}
                        style={{ width: "100%" }}
                        disabled={selectedLabelType2.value === ""}
                        slotProps={{ inputLabel: { style: { zIndex: 0 }, } }}
                      />
                    </Grid>
                    <Grid xs={3}>
                      <TextField
                        type="text"
                        variant="outlined"
                        size="small"
                        label="Attribute"
                        value={labelAttribute2}
                        required={selectedLabelType2 !== ""}
                        onChange={(e) => setLabelAttribute2(e.target.value)}
                        onBlur={(e) => {
                          setLabelAttribute2(e.target.value?.trim());
                        }}
                        style={{ width: "100%" }}
                        disabled={selectedLabelType2.value === ""}
                      />
                    </Grid>
                    {selectedLabelType2.value === "color" && (
                      <Grid xs={3}>
                        <TextField
                          type="color"
                          variant="outlined"
                          size="small"
                          label="Hex Color"
                          value={hexCode2}
                          required={selectedLabelType2 !== ""}
                          onChange={(e) => setHexCode2(e.target.value)}
                          onBlur={(e) => {
                            setHexCode2(e.target.value?.trim());
                          }}
                          style={{ width: "100%" }}
                          disabled={selectedLabelType2.value === ""}
                        />
                      </Grid>
                    )}
                  </Grid>
                </>
              )}
              {subCategory &&
                subCategory["enable_recommend_product"] === true && (
                  <Grid
                    container
                    spacing={2}
                    xs={12}
                    style={{ paddingTop: "16px" }}
                  >
                    <Grid xs={3}>
                      <CheckboxField
                        checked={recommendProduct}
                        onChange={(_, val) => {
                          setRecommendProduct(val);
                        }}
                        color="primary"
                        className="mr-2"
                      />
                      <Typography variant="body">
                        Recommended Product
                      </Typography>
                    </Grid>
                  </Grid>
                )}
            </Grid>
            <div
              style={{
                padding: "24px 0 12px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Button
                color="primary"
                variant="outlined"
                onClick={() => {
                  setLanguageAddModal(true);
                  setTemporaryData();
                }}
                style={{
                  visibility: enable_product_language ? "visible" : "hidden",
                }}
              >
                Add Language
              </Button>
              <div>
                <Button
                  color="primary"
                  variant="outlined"
                  onClick={handleClose}
                  style={{ marginRight: "8px" }}
                >
                  Close
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={
                    modulesSelected.length === 0 ? handleAdd : handleEdit
                  }
                  disabled={isMutating}
                >
                  {modulesSelected.length === 0 ? "Add" : "Save"}
                </Button>
              </div>
            </div>
          </DialogContent>
        </Dialog>
        <Dialog
          open={openDescriptionModal}
          onClose={() => {
            setOpenDescriptionModal(false);
            setDescriptionPreview("");
          }}
          maxWidth="md"
          fullWidth={true}
          style={{ display: "block" }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <Grid container>
              <Grid xs={6}>
                <DialogTitle style={{ padding: "0 0 16px" }}>
                  Description Preview
                </DialogTitle>
              </Grid>
              <Grid container>
                <Grid xs={12}>
                  <ReactQuill
                    value={descriptionPreview}
                    readOnly={true}
                    theme="bubble"
                  />
                </Grid>
              </Grid>
              <div
                style={{
                  paddingBottom: "12px",
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "100%",
                }}
              >
                <div>
                  <Button
                    color="primary"
                    variant="outlined"
                    onClick={() => {
                      setOpenDescriptionModal(false);
                      setDescriptionPreview("");
                    }}
                  >
                    Close
                  </Button>
                </div>
              </div>
            </Grid>
          </DialogContent>
        </Dialog>
        <CrudDialog
          title="Bulk Edit"
          okText="Save"
          description="Please edit the details below."
          crudLoader={crudLoader}
          fields={editFields1}
          submitButtonDisabled={isMutating}
          values={modulesSelected[0]}
          onFieldChange={(rec, val) => {
            if (rec?.key === "age_restriction") {
              if (val == 0) {
                setShowTimePeriod(false);
              } else {
                setShowTimePeriod(true);
              }
            }
            if (rec?.key === "hopper_limit") {
                setHopperLimitError(validateHopperLimit(val));
            }
          }}
          onSubmit={(values) => {
            handleCategoryEdit(values);
          }}
          open={categoryEditModal}
          onClose={() => {
            setCategoryEditModal(false);
            setShowTimePeriod(false);
          }}
        />
        <CrudDialog
          title="Delete Product"
          description={
            modulesSelected.findIndex((x) => x.has_variants === true) === 0
              ? "Deleting the product will also delete it's variants. Are you sure you want to delete?"
              : "Are you sure you want to delete the Product?"
          }
          okText="Delete"
          onSubmit={
            modulesSelected.findIndex((x) => x.has_variants === true) === 0
              ? () => handleForceDelete()
              : () => handleDelete()
          }
          open={deleteModal}
          onClose={() => setDeleteModal(false)}
        />

        <CrudDialog
          title="Delete Product Forcefully"
          description="Deleting the product will also delete it's variants. Are you sure you want to delete?"
          okText="Delete"
          onSubmit={() => handleForceDelete()}
          open={forcedeleteModal}
          onClose={() => {
            setForceDeleteModal(false);
            setDeleteModal(false);
          }}
        />
        <DialogWithTable
          open={languageAddModal}
          onClose={() => {
            setLanguageAddModal(false);
            setTemporaryData();
          }}
          onAdd={addEntry}
          onEdit={editEntry}
          onDelete={deleteEntry}
          tableData={tableData}
          languageList={
            languageList?.length
              ? [
                  ...languageList
                    .filter((x) => x.langauge != "English")
                    .map((x) => ({ label: x.langauge, value: x.id })),
                ]
              : [{ label: "", value: null }]
          }
          onDuplicate={updateExistingProducts}
          onCancelled={cancelEntry}
        />
        <InfoModal
          title="Product Import Errors"
          data={importError || []}
          open={isInfo}
          close={() => setIsInfo(false)}
        />
      </div>
    </div>
  );
};
export default withStyles({}, { withTheme: true })(Product);
